import { QuestionStatusTypes } from '@shared/enums';

export interface Question {
  QuestionId: number;
  Display: string;
  StatusType: QuestionStatusTypes;
}
